import React from 'react';
import { Routes, Route } from 'react-router-dom';

import NotFound from 'components/shared/notFound/page/NotFound';

const SwitchWith404 = ({ children }) => (
  <Routes>
    {children}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default SwitchWith404;
